{
  "TITLE": "Name",
  "MESSAGE": "Message",
  "SMS_REGISTRATION": {
    "ALERT": {
      "BUSINESS_INFO_REQUIRED_TITLE": "Business information required",
      "MORE_DETAILS_SUGGESTION": "More details are needed about your business to send SMS messages to customers.",
      "UPDATE_INFO_ACTION_TITLE": "Update business info",
      "REJECTED_TITLE": "SMS registration rejected",
      "REJECTED_SUGGESTION": "update your information and try submitting again to access SMS features."
    },
    "INFO_BANNER": {
      "LEARN_MORE": "Learn more"
    }
  },
  "SMS_BUILDER": {
    "SMS_CONFIGURATION": "SMS Configuration",
    "PREVIEW": "Preview"
  },
  "SMS_REGULATION": {
    "COMMON": {
      "SUBMIT": "Submit information",
      "ADDRESS": {
        "STREET_ADDRESS_PRIMARY": "Address",
        "STREET_ADDRESS_SECONDARY": "Additional address line",
        "CITY": "City",
        "STATE": "State/Province",
        "POSTAL_CODE": "Postal code"
      },
      "FILE_UPLOADER": {
        "ACCEPTED_FILE_TYPES": "A PDF, JPG or PNG file. Up to {{ numberOfMegabytes }} MB"
      }
    },
    "SOUTH_AFRICA": {
      "TITLE": "South African SMS Regulatory Compliance Form",
      "SUBTITLE": "This information is required to get a South African SMS number",
      "BUSINESS_IDENTITY": {
        "TITLE": "Business Identity",
        "BUSINESS_NAME": "Business name",
        "BUSINESS_REGISTRATION_NUMBER": "Business registration number",
        "ACCEPTED_DOCUMENTS": {
          "TITLE": "Proof of business identity",
          "HINT": "The type of document uploaded as proof of business identity",
          "BUSINESS_REGISTRATION": "Business registration",
          "CERTIFIED_LETTERHEAD": "Certified copy of business letterhead or similar document"
        }
      },
      "BUSINESS_ADDRESS": {
        "TITLE": "Business Address",
        "ACCEPTED_DOCUMENTS": {
          "TITLE": "Proof of address",
          "HINT": "The type of document uploaded as proof of address",
          "BANK_STATEMENT": "Bank statement",
          "MUNICIPAL_RATES_OR_TAX_INVOICE": "Municipal rates or tax invoice",
          "RECENT_PHONE_BILL": "Recent phone bill",
          "NEW_VEHICLE_LICENSE": "New motor vehicle license"
        }
      },
      "AUTHORIZED_REPRESENTATIVE": {
        "TITLE": "Authorized business representative",
        "FIRST_NAME": "First name",
        "LAST_NAME": "Last name",
        "IDENTITY_NUMBER": "Identity number",
        "IDENTITY_NUMBER_HINT": "The identity number for your government issued ID",
        "NATIONALITY": "Nationality",
        "ACCEPTED_DOCUMENTS": {
          "TITLE": "Proof of identity",
          "HINT": "Upload your government issued ID (must include full name and identity number)",
          "GOVERNMENT_ISSUED_ID": "Government issued ID"
        }
      }
    }
  }
}
